var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-group"},[_c('ui-box',{staticClass:"question-group__title",class:{
      'py-12px': _vm.$media.desktop,
      'py-24px': _vm.$media.widescreen
    }},[_c('h4',{staticClass:"is-size-6 has-text-weight-bold"},[_vm._v(_vm._s(_vm.title))])]),_c('ui-box',{class:{
      'pt-12px': _vm.$media.desktop,
      'pt-24px': _vm.$media.widescreen,
      'pb-24px': _vm.$media.desktop,
      'pb-32px': _vm.$media.widescreen
    }},_vm._l((_vm.questions),function(question){return _c('question',{key:question.uniqueKey,attrs:{"question":question,"language":_vm.language}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }